module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image1_infinite-50dd4d5cb3a74999bc36ecd8fc4a6cc9.png";